import React from 'react';
import './index.css';
import BusinessWebsite from './components/BusinessWebsite';

function App() {
  return (
    <div className="App">
      <BusinessWebsite />
    </div>
  );
}

export default App; 